export const MOBILE_MAX_WIDTH_PX = 900;
export const GUIDE_MOBILE_MAX_WIDTH_PX = 520;
export const PAGE_GUTTER_DESKTOP_PX = 32;
export const PAGE_GUTTER_MOBILE_PX = 16;
export const BOTTOM_NAV_HEIGHT_PX = 64;

export const mediaMobile = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`;
export const mediaDesktop = `(min-width: ${MOBILE_MAX_WIDTH_PX + 1}px)`;
/** True for mouse/trackpad — avoids sticky :hover on touch (e.g. iPhone sign grids). */
export const mediaCanHover = "(hover: hover) and (pointer: fine)";

export function responsiveGridColumns(isMobile, { desktop, mobile = "1fr" }) {
  return isMobile ? mobile : desktop;
}

export function pageGutterPx(isMobile) {
  return isMobile ? PAGE_GUTTER_MOBILE_PX : PAGE_GUTTER_DESKTOP_PX;
}
